export default {
  // Page title
  'page.title': '计时器',
  
  // Popular timers
  'popular.title': '常用计时器',
  'popular.10s': '10秒倒计时',
  'popular.20s': '20秒倒计时',
  'popular.30s': '30秒倒计时',
  'popular.40s': '40秒倒计时',
  'popular.50s': '50秒倒计时',
  'popular.90s': '1分半倒计时',
  'popular.2minute': '2分倒计时',
  'popular.3minute': '3分倒计时',
  'popular.5minute': '5分倒计时',
  'popular.10minute': '10分倒计时',
  'popular.15minute': '15分倒计时',
  'popular.30minute': '30分倒计时',
  'popular.60minute': '60分倒计时',
  'popular.1hour': '1小时倒计时',
  'popular.10hour': '10小时倒计时',
  'popular.24hour': '24小时倒计时',
  'popular.48hour': '48小时倒计时',
  
  // How to use
  'howto.title': '如何设置计时器',
  'howto.titleMinutes': '如何设置{{minutes}}分钟计时器',
  'howto.titleSeconds': '如何设置{{seconds}}秒计时器',
  'howto.titleHour': '如何设置{{hours}}小时计时器',
  'howto.titleHours': '如何设置{{hours}}小时计时器',
  'howto.step1': '⚙️ 设置时间：点击小时或分钟数字可直接编辑时间，最多可设置23小时59分钟，适用于任何任务。',
  'howto.step2': '⚡ 快速调整：使用便捷的快捷按钮，可瞬间添加30秒、1分钟、5分钟、10分钟或30分钟到您的计时器。',
  'howto.step3': '▶️ 开始控制：点击"开始"开始倒计时。您可以随时暂停休息并在准备好时继续，或重置重新开始。',
  'howto.step4': '🔔 获取通知：时间到时接收桌面通知和可定制的声音提醒。可在右上角开关声音提醒。',
  'howto.step5': '🖥️ 全屏模式：点击全屏按钮获得无干扰的计时体验 - 非常适合演示、冥想或专注工作。',
  'howto.step6': '📱 随处使用：适用于任何设备 - 桌面、平板或手机。无需下载，直接在浏览器中使用。',
  
  // User review submission
  'reviewSubmission.title': '分享您的体验',
  'reviewSubmission.subtitle': '分享您的使用体验，帮助其他用户发现这个计时器',
  'reviewSubmission.ratingLabel': '为您的体验评分',
  'reviewSubmission.commentLabel': '您的评价 (可选)',
  'reviewSubmission.commentPlaceholder': '告诉我们这个计时器如何帮助您提高效率、烹饪、学习或其他活动...',
  'reviewSubmission.nameLabel': '您的姓名 (可选)',
  'reviewSubmission.namePlaceholder': '我们应该如何显示您的姓名？',
  'reviewSubmission.submitButton': '提交评价',
  'reviewSubmission.thankYou': '感谢您的评价！',
  'reviewSubmission.thankYouMessage': '您的反馈帮助我们改进产品，也帮助其他人发现我们的计时器。',
  'reviewSubmission.error': '请在提交前选择评分。',

  // User reviews
  'reviews.title': '用户真实评价',
  'reviews.newReview': '最新评价',
  'reviews.mikeZhang': '提高效率的游戏改变者！用这个计时器配合番茄工作法帮我完成了毕业论文。界面简洁，无干扰。',
  'reviews.lisaLee': '厨房计时完美工具！再也不会煮过头鸡蛋了。声音提醒响亮但不刺耳，我妈妈也很喜欢用。',
  'reviews.johnDeveloper': '史上最好的编程休息计时器！预设按钮节省很多时间，有效预防眼疲劳，保持专注状态。',
  'reviews.msChen': '改变了我的课堂管理！学生们现在居然很享受计时活动，视觉倒计时让所有人都保持专注。',
  'reviews.fitnessPro': 'HIIT训练的革命性工具！计时精准，即使手出汗也容易操作，学员们都喜欢全屏模式。',
  'reviews.sarahMarketer': '会议效率提升40%！不再有无休止的讨论，时间限制迫使大家做决定并保持专注。',
  'reviews.tomChef': '餐厅厨房必备！面条、牛排、酱汁 - 每次都完美计时。多个快捷按钮设计太棒了。',
  'reviews.amyStudent': '学习游戏改变者！打破拖延循环，用可管理的时间块学习。从C等升到A等全靠这个方法。',
  'reviews.davidWriter': '治愈了我的写作障碍！15分钟写作冲刺创造动力，这个月发表了3篇文章，全靠这个计时器。',
  'reviews.rachelTherapist': '和客户冥想疗程的完美工具。温和的提醒不会破坏平静氛围，非常专业。',
  // Preset timer specific reviews
  'reviews.managerZhang': '办公必备！泡茶、会议休息时间控制很棒，界面简洁不影响工作专注度。',
  'reviews.mrsLi': '完美的煮蛋计时器！3分钟溏心蛋每次都刚好，声音提醒很贴心，再也不会煮老了。',
  'reviews.programmerWang': '编程护眼必备，3分钟眼部放松刚刚好，缓解眼疲劳效果很棒！',
  
  // Use cases
  'useCases.title': '{{minutes}}分钟计时器使用场景',
  'useCases.titleSeconds': '{{seconds}}秒计时器使用场景',
  'useCases.titleHours': '{{hours}}小时计时器使用场景',

  // Page titles
  'pageTitle': '{{minutes}}分钟计时器',
  'pageTitleSeconds': '{{seconds}}秒计时器',
  'pageTitleHour': '{{hours}}小时计时器',
  'pageTitleHours': '{{hours}}小时计时器',
  
  // User names
  'user.mikeZhang': '张明',
  'user.lisaLee': '李丽',
  'user.johnDeveloper': '程序员小王',
  'user.msChen': '陈老师',
  'user.fitnessPro': '健身教练',
  'user.sarahMarketer': '市场营销莎拉',
  'user.tomChef': '大厨老汤',
  'user.amyStudent': '学生小艾',
  'user.davidWriter': '作家大卫',
  'user.rachelTherapist': '治疗师瑞秋',
  // Preset timer specific users
  'user.managerZhang': '张经理',
  'user.mrsLi': '李太太',
  'user.programmerWang': '程序员王',

  // Use cases
  'useCases.quickBreak.title': '快速休息',
  'useCases.quickBreak.desc': '工作间隙的短暂休息，刷新大脑，预防疲劳倦怠',
  'useCases.eyeCare.title': '护眼提醒',
  'useCases.eyeCare.desc': '遵循20-20-20法则：每20分钟看20英尺外的东西20秒',
  'useCases.teaBrewing.title': '茶叶冲泡',
  'useCases.teaBrewing.desc': '绿茶(3分钟)、红茶(5分钟)或花草茶的完美冲泡时间',
  'useCases.lightExercise.title': '轻度运动',
  'useCases.lightExercise.desc': '办公室拉伸、桌面瑜伽或简单运动，对抗久坐生活方式',
  'useCases.meditation.title': '正念冥想',
  'useCases.meditation.desc': '引导呼吸练习、正念练习或压力缓解冥想',
  'useCases.softBoiledEggs.title': '烹饪计时',
  'useCases.softBoiledEggs.desc': '溏心蛋(5分钟)、煮面条或任何厨房任务的完美计时',
  'useCases.quickReading.title': '专注阅读',
  'useCases.quickReading.desc': '书籍、文章或学习材料的集中阅读时间',
  'useCases.phoneCall.title': '通话会议计时',
  'useCases.phoneCall.desc': '保持电话畅通、限制会议时长或演示计时',
  'useCases.focusedWork.title': '番茄工作法',
  'useCases.focusedWork.desc': '经典番茄工作法 - 25分钟专注工作后休息',
  'useCases.exercise.title': '锻炼训练',
  'useCases.exercise.desc': '高强度间歇、循环训练或特定运动时长',
  // 15-minute specific
  'useCases.shortMeeting.title': '站立会议',
  'useCases.shortMeeting.desc': '快速团队更新、每日站会或简短协作讨论',
  'useCases.powerNap.title': '能量小憩',
  'useCases.powerNap.desc': '最佳午睡时长，提升精力而不产生困倦感',
  'useCases.learning.title': '学习时段',
  'useCases.learning.desc': '语言练习、技能教程或教育视频片段',
  'useCases.creativity.title': '创意冲刺',
  'useCases.creativity.desc': '头脑风暴会议、写作冲刺或艺术练习',
  // 30-minute specific
  'useCases.deepWork.title': '深度工作',
  'useCases.deepWork.desc': '复杂任务的专注工作时间，减少干扰',
  'useCases.workout.title': '完整训练',
  'useCases.workout.desc': '完整运动套路、瑜伽课程或结构化训练计划',
  'useCases.study.title': '学习模块',
  'useCases.study.desc': '考试强化学习、研究或技能发展',
  'useCases.presentation.title': '演讲练习',
  'useCases.presentation.desc': '排练演讲、练习推销或计时演示表达',

  // Timer-specific user reviews
  // 1-minute timer users
  'user.officeWorkerAlex': '办公室小李',
  'user.developerSarah': '程序员小雅',
  'user.designerMike': '设计师小明',
  'reviews.officeWorkerAlex': '会议间隙快速休息的完美工具！只需1分钟伸展和重新专注，效果很明显。',
  'reviews.developerSarah': '20-20-20护眼法则必备！每20分钟看20英尺外的东西1分钟，眼睛舒服多了！',
  'reviews.designerMike': '高强度设计工作时的微休息利器，时间短但很有效，预防工作疲劳。',

  // 3-minute timer users  
  'user.teaLoverEmily': '茶艺师小雨',
  'user.yogatrainerJohn': '瑜伽教练阿强',
  'user.busyMomLisa': '宝妈丽丽',
  'reviews.teaLoverEmily': '绿茶冲泡的完美时间！3分钟泡出来的茶味道刚好，不苦涩。声音提醒很贴心！',
  'reviews.yogatrainerJohn': '我用它给学员做快速呼吸练习，3分钟刚好适合平静心情的训练时长。',
  'reviews.busyMomLisa': '孩子刷牙计时神器！现在他们居然很享受倒计时刷牙的过程。',

  // 5-minute timer users
  'user.meditatorZen': '冥想达人',
  'user.chefTony': '大厨老王',
  'user.runnerMia': '跑步爱好者小美',
  'reviews.meditatorZen': '初学者冥想的完美时长，5分钟既能坚持又很有效果，正念练习的好帮手。',
  'reviews.chefTony': '厨房必备工具！煮溏心蛋每次都完美，专业可靠，值得信赖。',
  'reviews.runnerMia': '跑后拉伸专用，5分钟确保我不会跳过恢复训练，保护身体很重要！',

  // 10-minute timer users
  'user.studentDavid': '学生小大卫',
  'user.managerRachel': '项目经理瑞秋',  
  'user.writerJames': '作家老詹',
  'reviews.studentDavid': '学习休息的好工具！10分钟刚好能让大脑重置又不会失去学习动力。',
  'reviews.managerRachel': '专注阅读时间管理利器，每天10分钟不间断阅读真的积少成多！',
  'reviews.writerJames': '定时写作冲刺必备，10分钟的时间压力帮我克服写作障碍，灵感爆发！',

  // 15-minute timer users
  'user.consultantAmy': '咨询师小艾',
  'user.teacherBen': '老师小本',
  'user.freelancerSophie': '自由职业者苏菲',
  'reviews.consultantAmy': '客户电话和站会的理想时长，让讨论保持专注和高效，时间管理好帮手。',
  'reviews.teacherBen': '课堂活动和小组作业计时器，学生们在有时间限制时更专注投入。',
  'reviews.freelancerSophie': '完美的番茄工作法！15分钟专注工作+休息，让我一整天都保持高效率。',

  // 30-minute timer users
  'user.executiveRobert': '高管老罗',
  'user.fitnessCoachMaya': '健身教练玛雅',
  'user.artistOlivia': '艺术家小欧',
  'reviews.executiveRobert': '深度工作时间的完美选择，30分钟能有意义的进展又不会有太大压力。',
  'reviews.fitnessCoachMaya': '完整训练循环的理想时长，学员们很喜欢这种结构化的训练节奏安排。',
  'reviews.artistOlivia': '创作时光的最佳伴侣，30分钟足够进入心流状态，创造出有意义的作品。',
};